export default __webpack_public_path__ + "static/georg_neu-1db411ffcd0cb629f57db3b25e17f5cf.png";